/**
 * Aurelior Maison - Collection hero banner: click/tap scrolls smoothly to
 * this page's own product grid (#product-grid - id, markup, and the
 * empty-collection fallback are already defined once in sections/main-
 * collection-product-grid.liquid; this only reads that id, never
 * duplicates it) - or, on the Final Collection only, to the #product-grid-
 * featured row rendered by sections/aurelior-collection-featured-pair.liquid
 * just above the benefits section. Only loaded on Collection pages - see
 * the ach_clickable gate in sections/aurelior-collection-hero.liquid, which
 * is also what keeps the Homepage's own instance of this same shared
 * section inert.
 *
 * Header-height offset reuses the exact technique already proven in
 * assets/aurelior-product-overlay.js: the LAST .shopify-section-group-
 * header-group element's live bottom edge is the real, current height of
 * the header/announcement-bar stack (correct at every breakpoint and
 * announcement-bar state) - not a hardcoded pixel value.
 */
(function () {
  function headerOffset() {
    var groups = document.querySelectorAll('.shopify-section-group-header-group');
    var last = groups[groups.length - 1];
    return last ? last.getBoundingClientRect().bottom : 0;
  }

  function scrollToProductGrid() {
    // Final Collection only: sections/aurelior-collection-featured-pair.liquid
    // renders Thornbury + Tarrant above the benefits section with this id,
    // so the hero scrolls there instead of the (now further down) main
    // grid. Every other collection page has no such element, so this falls
    // back to the original #product-grid - zero behavior change there.
    var grid = document.getElementById('product-grid-featured') || document.getElementById('product-grid');
    if (!grid) return;

    var gap = 16;
    var targetY = grid.getBoundingClientRect().top + window.scrollY - headerOffset() - gap;
    if (targetY < 0) targetY = 0;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: targetY, left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  // Defensive only: there is no interactive element nested inside the hero
  // today, but if one is ever added, its own click/keypress should win
  // instead of being hijacked by the hero's scroll behavior.
  function isRealInteractiveTarget(event) {
    return !!event.target.closest('a, button, input, select, textarea');
  }

  document.addEventListener('click', function (event) {
    var hero = event.target.closest('[data-collection-hero-scroll]');
    if (!hero || isRealInteractiveTarget(event)) return;
    scrollToProductGrid();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    var hero = event.target.closest('[data-collection-hero-scroll]');
    if (!hero || isRealInteractiveTarget(event)) return;
    event.preventDefault();
    scrollToProductGrid();
  });
})();
